export default [
  {
    label: 'オートキャンプ',
    value: 'vehicles_autocamp',
  },
  {
    label: 'キャンピングカー乗り入れ可',
    value: 'vehicles_campingcar',
  },
];
